import { slideToggle } from '../module/slideToggle';

/**
 * アコーディオンコンポーネント
 * @constructor
 * @param {HTMLElement} trigger アコーディオン開閉ボタン
 */


export default class Accordion {
  constructor(trigger) {
    /** @member {HTMLElement} アコーディオン開閉ボタン */
    this.trigger = trigger
    this.accordion = trigger.closest('.js-accordion')

    /** @member {HTMLElement} アコーディオンのパネル部分 */
    this.panel = this.accordion.querySelector('.js-accordionBody')

    this.handleClick()
  }

  /**
   * クリックイベントを処理する
   */
  handleClick() {
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault()
      this.accordionToggle()
    })
  }

  /**
   * 開閉を切り替える
   */
  accordionToggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  };

  /**
   * 開いているか？
   * @returns {boolean} 判定結果
   */
  isOpen() {
    return this.accordion.classList.contains('is-open')
  };

  /**
   * 開く
   */
  open() {
    this.accordion.classList.add('is-open')
    slideToggle(true, this.panel);

  };

  /**
   * 閉じる
   */
  close() {
    this.accordion.classList.remove('is-open')
    slideToggle(false, this.panel);
  };

  /**
   * 初期化
   * @param {string} selector 初期化対象のセレクター
   */
  static init(selector) {
    document.querySelectorAll(selector)
      .forEach(element => new Accordion(element));
  };
}



